import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {group} from '@angular/animations';
import {AccordionModule} from "primeng/accordion";
import {NgForOf, NgIf} from "@angular/common";
import {ToggleButtonModule} from "primeng/togglebutton";
import {FormsModule} from "@angular/forms";
import {InputText} from 'primeng/inputtext';

@Component({
  standalone: true,
  selector: 'app-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  imports: [
    AccordionModule,
    NgIf,
    ToggleButtonModule,
    FormsModule,
    NgForOf,
    InputText
  ],
  styleUrls: ['./checkbox-list.component.scss']
})
export class CheckboxListComponent implements OnInit, OnDestroy {

  @Input()
  isGrouped = false;

  private _originalItems: any[] = [];
  private _items: any[] = [];

  @Input()
  set items(value: any[]) {
    if (this._originalItems.length === 0) {
      this._originalItems = value;
    }
    this._items = value;
  }

  get items() {
    return this._items;
  }

  @Input()
  filterable = false;

  @Input()
  selectedItems: any[] = [];

  @Input()
  optionLabel = 'label';

  @Input()
  optionValue = 'value';

  @Input()
  groupName = 'group';

  @Input()
  gridColumnClass = 'col-4';

  constructor() {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

  getLabel(item: any): string {
    return item[this.optionLabel];
  }

  private getItemId(item: any) {
    return !!item ? item[this.optionValue] : null;
  }

  isSelected(item: any) {
    if (!item) {
      return false;
    }
    const id = this.getItemId(item);
    return this.selectedItems.some(x => this.getItemId(x) === id);
  }

  setSelected(item: any, selected: boolean) {
    const id = this.getItemId(item);
    if (selected) {
      if (!this.selectedItems.some(x => this.getItemId(x) === id)) {
        this.selectedItems.push(item);
      }
    } else {
      if (this.selectedItems.some(x => this.getItemId(x) === id)) {
        const index = this.selectedItems.findIndex(x => this.getItemId(x) === id);
        this.selectedItems.splice(index, 1);
      }
    }
  }

  getGroupName(item: any): string {
    return item[this.groupName];
  }

  getItemsFromGroupName(groupName: string) {
    return this.sortItems(this.items.filter(item => this.getGroupName(item) === groupName));
  }

  getSortedItems() {
    return this.sortItems(this.items);
  }

  private sortItems(items: any[]) {
    return items.sort((a, b) => this.getLabel(a).localeCompare(this.getLabel(b)));
  }

  getGroupNames() {
    return [...new Set(this.items.map(item => this.getGroupName(item)))];
  }

  getAccordionTitle(groupName: string): string {
    const groups = this.getItemsFromGroupName(groupName);
    const total = groups.length;
    const selected = groups.filter(item => this.isSelected(item)).length;
    return `${groupName} (${selected}/${total})`;
  }

  filterItems(event: any) {
    const value = event.target.value;
    this.items = this._originalItems.filter(item => this.getLabel(item).toLowerCase().includes(value.toLowerCase()));
  }
}
